export default __webpack_public_path__ + "static/media/avatar_176.afc0bbf5.png";